import React, { Component } from 'react'

export default class FundAnalysisTips extends Component {
  handleOk(){
		this.props.onOK();
	}
  render() {
    return (
      <div style = {styles.container}>
        <div style = {styles.modalView}>
          <div style={{paddingLeft:25,paddingRight:25,paddingTop:25}}>
            <div style = {{fontSize:14,lineHeight:'20px',color:"#333333"}}>波动率：衡量基金的收益率变化程度的指标，数值越小表示该基金的抗风险波动能力越强，反之则越弱。</div>
            <div style = {{fontSize:14,lineHeight:'20px',color:"#333333"}}>夏普比率：计算基金每承受一单位风险，可获得的超额收益，数值为正时越大越好，表示基金的性价比越高。</div>
            <div style = {{fontSize:14,lineHeight:'20px',color:"#333333"}}>最大回撤：表示在一定区间内，基金净值从最高点到最低点的下降幅度，体现该基金在此区间内的最大亏损。数值越大表示该基金的风险控制能力越强</div>
          </div>
          <div onClick = {()=>{this.handleOk()}} style={{...styles.footHeight,width: 273,height:43,borderTop:'1px solid #EBEBEB',marginTop:20}}>
            <div style = {{fontSize: 14,color:'#333',lineHeight:'20px',fontWeight:"500"}}>知道了</div>
          </div>
        </div>
			</div>
    )
  }
}
const styles = {
	container: {
		position: 'absolute',
		width: '100%',
		top: 0, 
		bottom: 0,
		backgroundColor: 'rgba(0,0,0,0.5)',
		zIndex: 999,
		justifyContent: 'center',
		alignItems: 'center',
    display:'flex'
	},
	modalView: {
		backgroundColor: '#ffffff',
		borderRadius: 15,
		width: 273,
	},
	titleText: {
		fontSize: 16,
		color: '#474747',
		marginTop:28,
	},
	contentText: {
		color: '#474747',
		fontSize: 12,
		lineHeight: '18px',
		marginTop: 20,
		marginLeft: 20,
		marginRight: 20,
		marginBottom: 5
	},
	footHeight: {
    display:'flex',
		alignSelf: 'stretch',
		flex:1,
		alignItems: 'center',
		width: 273,
		justifyContent:'center',
		borderColor: '#ebeef0',
		borderBottomLeftRadius: 15,
		borderBottomRightRadius: 15
	},
	footView: {
		alignSelf: 'stretch',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius:30,
		backgroundColor:"#FA063A",
		width:210,
    display:'flex'
	},
	footText: {
		color: '#f8986a',
		fontSize: 15,
	}
}



// WEBPACK FOOTER //
// ./src/components/product/tip/FundAnalysisTips.js